function RefreshIcon({ className }) {
  return (
    <svg className={`ic ${className}`} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18.6505 8.35L15.8605 11.14C15.5405 11.46 15.7605 12 16.2105 12H18.0005C18.0005 15.31 15.3105 18 12.0005 18C11.2105 18 10.4405 17.85 9.75052 17.56C9.39052 17.41 8.98052 17.52 8.71052 17.79C8.20052 18.3 8.38052 19.16 9.05052 19.43C9.96052 19.8 10.9605 20 12.0005 20C16.4205 20 20.0005 16.42 20.0005 12H21.7905C22.2405 12 22.4605 11.46 22.1405 11.15L19.3505 8.36C19.1605 8.16 18.8405 8.16 18.6505 8.35ZM6.00052 12C6.00052 8.69 8.69052 6 12.0005 6C12.7905 6 13.5605 6.15 14.2505 6.44C14.6105 6.59 15.0205 6.48 15.2905 6.21C15.8005 5.7 15.6205 4.84 14.9505 4.57C14.0405 4.2 13.0405 4 12.0005 4C7.58052 4 4.00052 7.58 4.00052 12H2.21052C1.76052 12 1.54052 12.54 1.86052 12.85L4.65052 15.64C4.85052 15.84 5.16052 15.84 5.36052 15.64L8.15052 12.85C8.46052 12.54 8.24052 12 7.79052 12H6.00052Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default RefreshIcon;
